import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import * as messagesES from 'devextreme/localization/messages/es.json';
import { loadMessages, locale } from 'devextreme/localization';

if (environment.production) {
  enableProdMode();
}
loadMessages(messagesES); // Cargar los mensajes en español
locale('es-MX'); // Establecer el idioma español
platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
